var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('custom-multi-search', {
    attrs: {
      "searchTypes": _vm.searchTypes,
      "searchItems": _vm.searchItems,
      "defaultSearchType": {
        param: 'title',
        text: 'Title'
      },
      "readonly": _vm.readonly && !_vm.copyMode
    },
    on: {
      "updated": search => _vm.$emit('updated', search)
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };